// extracted by mini-css-extract-plugin
export default {"swiper":"carousel_swiper__TZpQq","prev":"carousel_prev__pCygX","next":"carousel_next__w6lPg"};